{
	"meta": {
		"title": "Empleo — UpSquad",
		"description": "Únete a UpSquad — buscamos ingenieros, diseñadores y operadores que reconstruyen lo que el software de comunidades debería ser."
	},
	"hero": {
		"eyebrow": "Empleo",
		"title": "Construye el futuro del",
		"title_accent": "software de comunidades.",
		"subtitle": "Equipo pequeño y enfocado. Misión grande y ambiciosa. Remoto-first, con presencia en Memphis y Nueva York."
	},
	"perks": {
		"remote": {
			"title": "Remoto-first",
			"body": "Trabaja desde donde quieras"
		},
		"equity": {
			"title": "Equity para todos",
			"body": "Upside real, desde el día uno"
		},
		"learning": {
			"title": "Presupuesto de aprendizaje",
			"body": "Libros, cursos, eventos"
		},
		"async": {
			"title": "Asíncrono-first",
			"body": "Deep work, menos ruido"
		}
	},
	"culture": {
		"title": "Cómo",
		"title_accent": "trabajamos.",
		"items": {
			"async": {
				"title": "Asíncrono y remoto",
				"description": "Mañanas de trabajo profundo, tardes con pocas reuniones, comunicación asíncrona primero."
			},
			"ownership": {
				"title": "Ownership por encima de la política",
				"description": "Contratamos perfiles senior, compartimos contexto y dejamos que cada persona sea dueña de los resultados de principio a fin."
			},
			"craft": {
				"title": "Oficio por encima de velocidad",
				"description": "Entregamos rápido — pero nunca a costa de la calidad. La vara está alta, a propósito."
			},
			"learning": {
				"title": "Presupuesto de aprendizaje",
				"description": "Libros, cursos, conferencias. Invertimos en nuestro equipo porque ellos invierten en el producto."
			}
		}
	},
	"openings": {
		"title": "Posiciones abiertas",
		"empty_title": "No tenemos posiciones abiertas ahora",
		"empty_subtitle": "Siempre nos interesan las personas con talento. Escríbenos y guardaremos tu CV.",
		"empty_cta": "Envía tu CV"
	}
}
